import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import TrainingHelpService from "../../apiServices/masters/trainingHelpService";
import { setTrainingHelp, setTrainingHelps } from "../../store/slices/master/trainingHelpSlice";

export function getTrainingHelp(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.getTrainingHelp(id);
    if (response?.success === true) {
      dispatch(setTrainingHelp(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getTrainingHelps(pageBlock?: number, noOfItems?: number, configUserType?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.getTrainingHelps(pageBlock, noOfItems, configUserType);
    if (response?.success === true) {
      dispatch(setTrainingHelps(response.data));
    } else {
      console.log("error");
    }
  };
}


export function createTrainingHelp(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.createTrainingHelp(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTrainingHelp(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.updateTrainingHelp(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTrainingHelpPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.updateTrainingHelpPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteTrainingHelp(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingHelpService.deleteTrainingHelp(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
